import apiClient from "./axios"

// ✅ Get accessory use requests (with filters / pagination)
export const getAccessoryUseRequestList = async (params = {}) => {
  const { data } = await apiClient.get("/accessory-use-requests", { params })
  return data
}

// ✅ Get single accessory use request by ID
export const getAccessoryUseRequestById = async id => {
  const { data } = await apiClient.get(`/accessory-use-requests/${id}`)
  return data
}

// ✅ Create accessory use request
export const createAccessoryUseRequest = async payload => {
  const { data } = await apiClient.post("/accessory-use-requests", payload)
  return data
}

// ✅ Update accessory use request
export const updateAccessoryUseRequest = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/accessory-use-requests/${id}`, payload)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteAccessoryUseRequest = async id => {
  const { data } = await apiClient.delete(`/accessory-use-requests/${id}`)
  return data
}

// ✅ Get trashed accessory use requests
export const getTrashedAccessoryUseRequests = async (params = {}) => {
  const { data } = await apiClient.get("/accessory-use-requests/trashed", {
    params,
  })
  return data
}

// ✅ Restore trashed accessory use request
export const restoreAccessoryUseRequest = async id => {
  const { data } = await apiClient.post(`/accessory-use-requests/${id}/restore`)
  return data
}

// ✅ Permanently delete accessory use request
export const forceDeleteAccessoryUseRequest = async id => {
  const { data } = await apiClient.delete(
    `/accessory-use-requests/${id}/force-delete`
  )
  return data
}
